module.exports = __webpack_public_path__ + "static/media/relogio.605511ad.png";